export default "__VITE_ASSET__b8e75696__"